<template>
  <div class="modal fade fixed-right modal-manage-capabilities" tabindex="-1" role="dialog" aria-hidden="true" v-if="$userIsAdmin" id="capabilitiesModal">
    <div class="modal-dialog modal-dialog-vertical" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Manage Capabilities</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="modal-body">
          <div v-for="capability in capabilities" :key="capability.id">
            <div class="row mb-2">
              <h3 class="col-6">{{ capability.name }}</h3>
              <div class="col-3">
                <div class="form-check form-check-inline">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    v-model="capability.focus"
                    value="capability.focus"
                    name="focus"
                  >
                  <label class="form-check-label">Focus</label>
                </div>
              </div>
              <div class="col-3">

                <multiselect
                  type="text"
                  :name="capability.name + ' Level'"
                  v-validate="'required'"
                  v-model="capability.level"
                  :options="['foundational', 'intermediate']"
                  single
                  :class="[errorClass(capability.name + ' Level'), validClass(capability.name + ' Level')]"
                  data-vv-validate-on="input|blur"
                />

                <help-block :field="capability.name + ' Level'"/>
              </div>
            </div>

          </div>
        </div><!-- /.modal-body -->
      </div>
    </div>
  </div><!-- /.modal -->
</template>

<script>
import $ from 'jquery'
import { capabilitiesMethods, capabilitiesComputed } from 'vx/helpers'
import Multiselect from 'vue-multiselect'

export default {
  components: {
    Multiselect
  },

  async created () {
    try {
      await this.getCapabilities()
    } catch (e) {
    }
  },

  mounted () {
    $('#capabilitiesModal').on('hide.bs.modal', (event) => {
      if (this.errors.items.length !== 0) {
        event.preventDefault()
        return
      }
      this.updateCapabilities({ payload: this.capabilities })
      this.$noty.success('Saved capabilities')
    })
  },

  computed: {
    ...capabilitiesComputed
  },

  methods: {
    ...capabilitiesMethods
  }
}
</script>
